import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Components/Auth/Login";
import AdminDashboard from "./Components/Dashboard/AdminDashboard";
import DashboardHome from "./Components/Dashboard/DashboardHome";
import Clients from "./Components/AddClients/Clients";
import DetailsDoNo from "./Components/AddDono/DetailsDoNo";
import OrderDetail from "./Components/OrderDetails/OrederDetail";
import OrderNewEntry from "./Components/OrderDetails/OrderNewEntry";
import AllOrder from "./Components/OrderDetails/AllOrder";
import DoView from "./Components/AddDono/DoView";
import Lifter from "./Components/AddLifter/Lifter";
import Staff from "./Components/AddStaff/Staff";
import LifterAssView from "./Components/LilterAssign/LifterAssView";
import LifterPayView from "./Components/LilterPayment/LifterPayView";
import ClientPayView from "./Components/ClientPayment/ClientPayView";
import LifterDispatch from "./Components/LifterDispatch/LifterDispatch";
import BillView from "./Components/BillCreation/BillView";
import FreightPayment from "./Components/FreightPaymet/FreightPayment";
import LifterPayViewByDo from "./Components/LilterPayment/LifterPayViewByDo";
import Report from "./Components/Reports/Report";
import AssignPage from "./Components/Assign/AssignPage";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("access")
  );

  /* Sync state if token manually removed or storage changes */
  useEffect(() => {
    const handleStorage = () =>
      setIsAuthenticated(!!localStorage.getItem("access"));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Root Route — Login or Admin Dashboard */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <AdminDashboard setIsAuthenticated={setIsAuthenticated} />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          }
        >
          {/* Default Dashboard (home index) */}
          <Route index element={<DashboardHome />} />
          <Route path="dashboard" element={<DashboardHome />} />

          {/* Sidebar‑linked routes */}
          <Route path="addclients" element={<Clients />} />
          <Route path="lifter-user" element={<Lifter />} />
          <Route path="staff-user" element={<Staff />} />
          <Route path="entry_do_no" element={<DetailsDoNo />} />
          <Route path="lifter-assign-view" element={<LifterAssView />} />
          <Route path="lifter-payment-view" element={<LifterPayView />} />
          <Route path="party-payment-view" element={<ClientPayView />} />
          <Route path="lifter-dispatch-view" element={<LifterDispatch />} />
          <Route path="Order-entry" element={<OrderNewEntry />} />
          <Route path="Order_form" element={<OrderDetail />} />
          <Route path="all_order" element={<AllOrder />} />
          <Route path="do-view/:id" element={<DoView />} />
          <Route path="bill-view" element={<BillView />} />
          <Route path="freight-pay" element={<FreightPayment />} />
          <Route path="pay-view/:id" element={<LifterPayViewByDo />} />
          <Route path="assign" element={<AssignPage />} />

          {/* Reports (URL driven) */}
          <Route path="reports-view" element={<Report />} />
        </Route>

        {/* Fallback route if user tries unknown path */}
        <Route
          path="*"
          element={<Login setIsAuthenticated={setIsAuthenticated} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
